import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, inject, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AciPaymentService } from '../../../invoices/payments/aci-payment.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common'
import { NgxSpinnerService } from 'ngx-spinner';
import { NgModule } from '@angular/core';
import { InvoicesService } from '../../../services/invoices.service';
import { IndexedDbService } from '../../../services/indexeddb.service';

export class AppModule { }

@Component({
  selector: 'ngbd-modal-content',
  template: `<div class="modal-body text-center ac-success-msg" [style.display]="success?success:'none'">
    <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M31 0C13.95 0 0 13.95 0 31C0 48.05 13.95 62 31 62C48.05 62 62 48.05 62 31C62 13.95 48.05 0 31 0ZM24.8 46.5L9.3 31L13.671 26.629L24.8 37.727L48.329 14.198L52.7 18.6L24.8 46.5Z" fill="#168007"/>
    </svg>
    <h4 class="mt-3" style="font-size:24px;">Payment Successfully Done!</h4>
      <p class="ac-modelpara">{{name}}</p>
      <button type="button" class="close btn ac-btn-outline-primary ac-butncancel m-1 brdr" (click)="closed()">Close</button>
      <button type="button" class="btn ac-btn-primary m-1" (click)="navigateToAutoPay()">AutoPay Options</button>
    </div>
    <div class="modal-body text-center ac-error-msg" [style.display]="error?error:'none'">
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36 0C55.908 0 72 16.092 72 36C72 55.908 55.908 72 36 72C16.092 72 0 55.908 0 36C0 16.092 16.092 0 36 0ZM48.924 18L36 30.924L23.076 18L18 23.076L30.924 36L18 48.924L23.076 54L36 41.076L48.924 54L54 48.924L41.076 36L54 23.076L48.924 18Z" fill="#D30000"/>
    </svg>
    <h4 class="mt-3" style="font-size:24px;">Error!</h4>
      <p class="ac-modelpara mb-4">{{name}}</p>
      <button type="button" class="close btn ac-btn-outline-primary ac-butncancel" (click)="closed()">Close</button>

    </div>`
})

export class NgbdModalContent {
  @Input() name: any;
  @Input() status: any;
  @Input() success: any = "none";
  @Input() error: any = "none";
  @Input() className: any;
  isPayClicked: boolean = false;
  supportLanguages = ['en'];

  constructor(public activeModal: NgbActiveModal, private spinner: NgxSpinnerService,
    public translate: TranslateService) {

    this.translate.addLangs(this.supportLanguages);
    this.translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    var lang = browserLang?.match(/en|fr/) ? browserLang : 'en';
    translate.use(lang);
  }
  closed() {
    localStorage.removeItem("ban")
    localStorage.removeItem("cano")
    localStorage.removeItem("isSledCustomer")
    localStorage.removeItem("totalAmountToPay")
    this.activeModal.close();
    parent.location = "/invoices";
  }

  navigateToAutoPay() {
    localStorage.removeItem("ban")
    localStorage.removeItem("cano")
    localStorage.removeItem("isSledCustomer")
    localStorage.removeItem("totalAmountToPay")
    this.activeModal.close();
    parent.location = "/invoices/setting";
  }
}

@Component({
  selector: 'ngbd-modal-confirm',
  standalone: true,
  template: `
		<div class="modal-header">
			<h4 class="modal-title" id="modal-title">Disable Recurring Payment</h4>
			<button
				type="button"
				class="btn-close"
				aria-describedby="modal-title"
				(click)="cancel()"
			></button>
		</div>
		<div class="modal-body">
			<p>
				<strong>Are you sure you want to Disable Recurring Payment?</strong>
			</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
			<button type="button" class="btn btn-danger" (click)="deleteRecurring()">Ok</button>
		</div>
	`,
})

export class NgbdModalConfirm {

  modal = inject(NgbActiveModal);
  @Input() banNo: any;
  @Input() confirmationCode: any;

  constructor(private aciPaymentService: AciPaymentService) { }

  deleteRecurring() {
    this.aciPaymentService.showLoader = true;
    this.modal.close();
    this.aciPaymentService.deleteRecurring(this.banNo, this.confirmationCode).subscribe(
      (data: any) => {
        this.aciPaymentService.showLoader = false;
      },
      (error: any) => {
        this.aciPaymentService.showLoader = false;
        console.error("Error deleting recurring Payment", error);
      }
    )
  }

  cancel() {
    window.location.reload();
  }

}


@Component({
  selector: 'app-confirm-payment',
  templateUrl: './confirm-payment.component.html',
  styleUrls: ['./confirm-payment.component.css']
})
export class ConfirmPaymentComponent implements OnInit, AfterViewInit {

  token: any;
  paymentMethod: any;
  // @ViewChild('content', { static: true })
  // content!: ElementRef;

  @Input()
  paymentMethodd: any;

  recurringFalg: boolean = false;
  supportLanguages = ['en'];

  banNo = "";
  confirmationCode = "";
  openConfirmationModel = "";

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public aciPaymentService: AciPaymentService,
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
    private location: Location,
    private invoicesService: InvoicesService,
    private indexedDbService: IndexedDbService) {

    this.translate.addLangs(this.supportLanguages);
    this.translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    var lang = browserLang?.match(/en|fr/) ? browserLang : 'en';
    translate.use(lang);
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.paymentMethod = params['param1'];
    });

  }

  ngOnInit() {
    var data = JSON.parse(localStorage.getItem("InvoiceList") || "[]");
    var List = data.invoices;
    var ban = List[0] && List[0].bpNo;
    this.banNo = ban;
  }
  async ngAfterViewInit() {
    // await this.sleep(1000 * 1);
    (await this.invoicesService.getRecurringSchedule(this.banNo)).subscribe((flag: any) => {
      if (flag.status != "Inactive") {
        this.recurringFalg = true;
      }

      this.openConfirmationModel = flag.status;

      this.confirmationCode = flag.confirmationCode;
    });
    this.token = this.paymentMethodd.id;
    this.paymentMethod = this.paymentMethodd.paymentType;
  }

  sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  openSm(content: any) {
    this.modalService.open(content, { size: 'lg', centered: true, container: 'body' });
  }


  pay() {
    this.aciPaymentService.showLoader = true;
    console.log(this.recurringFalg)
    // if (this.recurringFalg) {
    //   this.aciPaymentService.recurring(this.token, this.paymentMethod, this.recurringFalg).subscribe((res: any) => {
    //     this.open("Success", res.message);
    //     this.aciPaymentService.showLoader = false;
    //   }, (err: any) => {
    //     console.log(err);
    //     this.open("Error", err);
    //   });
    // }
    this.indexedDbService.deleteInvoices(this.banNo)
    let isHistoricalPymt = this.location.path().includes("/historical-data")
    console.log("path", this.location.path())
    if (isHistoricalPymt)
      this.aciPaymentService.payHistorical(this.token, this.paymentMethod, this.recurringFalg).subscribe((res: any) => {
        this.open("Success", res.message);
        this.aciPaymentService.showLoader = false;
      }, (err: any) => {
        console.log(err);
        this.open("Error", err);
      });
    else
      this.aciPaymentService.pay(this.token, this.paymentMethod, this.recurringFalg).subscribe((res: any) => {
        this.open("Success", res.message);
        this.aciPaymentService.showLoader = false;
      }, (err: any) => {
        console.log(err);
        this.open("Error", err);
      });
  }

  open(status: any, message: any) {
    const modalRef = this.modalService.open(NgbdModalContent);
    if (status == "Success") {
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "block";
      modalRef.componentInstance.error = "none";
    } else {
      //modalRef.componentInstance.name =this.translate.instant("ASM.Invoices.error."+message);
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "none";
      modalRef.componentInstance.error = "block";
    }

  }

  close() {
    this.modalService.dismissAll('Cross click');
    localStorage.removeItem("InvoiceList")
    localStorage.removeItem("ban")
    localStorage.removeItem("cano")
    localStorage.removeItem("isSledCustomer")
    localStorage.removeItem("totalAmountToPay")
    parent.location = "/invoices";
  }

  openConfirmation() {
    if (this.openConfirmationModel == "Active") {
      const modalRef = this.modalService.open(NgbdModalConfirm);
      modalRef.componentInstance.banNo = this.banNo;
      modalRef.componentInstance.confirmationCode = this.confirmationCode;
    }
  }

}

